module.exports = __webpack_public_path__ + "img/pbtm1.651e1ef5.png";